module.exports = __webpack_public_path__ + "static/media/Hyaluron_Collagen_komplex_gel_retina.d02ebf37.png";